import { Component, Input, OnInit, OnDestroy, AfterViewInit , HostBinding, Output, EventEmitter, SimpleChanges, SimpleChange } from '@angular/core';
import { LatestBalanceModel } from '../../../models/consumer/latest-balance.model';
import { HistoryAccountModel } from '../../../models/consumer/history-account.model';
import { ConsumerService } from '../../../services/consumer.service';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { DataService } from '../../../services/data.service';
import { ConsumerDetailInjector } from '../consumer-detail-injector';

@Component({
    selector: 'account-balance-item',
    templateUrl: './account-balance-item.component.html',
})
export class AccountBalanceItemComponent implements AfterViewInit, OnDestroy {

    issues: any[] = [];
    consumerId: string;
    subscriptions: any[] = [];
    historyAccountsPageSize: number = 5;
    historyAccountsTotalPages: number = 1;
    historyAccounts: HistoryAccountModel[] = [];
    latestBalance: LatestBalanceModel;
    accountPage: number = 1;
    timePeriod: number = 1;
    isBalanceOwed: boolean = false;
    consumerHasBilling: boolean;
    consumerHasPayg: boolean;
    clientId: number;

    constructor(private consumerService: ConsumerService,
        private route: ActivatedRoute,
        private dataService: DataService,
        private router: Router,
        consumerDetailInjector: ConsumerDetailInjector
    ) {
        this.issues = consumerDetailInjector.issues;
        this.consumerHasBilling = consumerDetailInjector.consumerHasBilling;
        this.consumerHasPayg = consumerDetailInjector.consumerHasPayg;
    }

    ngAfterViewInit(): void {
        this.subscriptions.push(this.route.queryParams.subscribe(queryParams => {
            this.onInit();
        }));
    }

    onInfoClick() {
        swal({
            title: 'Account balance',
            html: '<p style="text-align: left;">This widget shows the current balance of the consumer account.</p>\
             <p style="text-align: left;">Typically a PAYG consumer will have an account balance of zero, however, if debt has been applied then the account balance will show this. The PAYG unit has a separate balance known as the credit status, see the credit status widget.</p>',
            confirmButtonText: 'Close',
            confirmButtonColor: '#00539f'
        });
    }

    onInit() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        this.subscriptions.push(this.route
            .params
            .subscribe(params => {
                this.consumerId = params['consumerId'];
            }));

        this.subscriptions.push(this.route
            .queryParams
            .subscribe(queryParams => {
                if (+queryParams['timePeriod']) {
                    this.timePeriod = +queryParams['timePeriod'];
                }

                if (+queryParams['accountPage']) {
                    this.accountPage = +queryParams['accountPage'];
                }

            }));

        this.consumerService.getLatestBalance(this.clientId, this.consumerId).then((balanceRes) => {
            if (balanceRes) {
                this.latestBalance = balanceRes;
                if (this.latestBalance.balance > 0) {
                    this.isBalanceOwed = true;
                } else if (this.latestBalance.balance < 0) {
                    this.latestBalance.balance = this.latestBalance.balance *= -1
                }
            }
        });

        this.consumerService.getHistoryAccount(this.clientId, this.accountPage, this.consumerId, this.timePeriod).then((accountRes) => {
            var result = (accountRes as any);
            this.historyAccounts = [];
            if (result && result.items.length > 0) {
                this.dataService.accountBalanceItemComponentResolved.next(true);
                this.historyAccounts = result.items;
                this.historyAccountsPageSize = result.pageSize;
                this.historyAccountsTotalPages = result.totalPages;

                if (this.accountPage > this.historyAccountsTotalPages) { this.accountPage = this.historyAccountsTotalPages; }
            } else { this.dataService.accountBalanceItemComponentResolved.next(false); }
        }).catch((reson) => {
            this.dataService.accountBalanceItemComponentResolved.next(false);
        })
    }

    pageSelected(page: number) {
        this.accountPage = page;
        this.getPage(page);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    getPage(page: number) {
        let queryParams: any = JSON.parse(JSON.stringify(this.route.snapshot.queryParams)) as any;
        queryParams.accountPage = page;

        this.consumerService.getHistoryAccount(this.clientId, page, this.consumerId, this.timePeriod).then((accountRes) => {
            var result = (accountRes as any);
            this.historyAccounts = [];
            if (result && result.items.length > 0) {
                this.dataService.accountBalanceItemComponentResolved.next(true);
                this.historyAccounts = result.items;
                this.historyAccountsPageSize = result.pageSize;
                this.historyAccountsTotalPages = result.totalPages;
            } else { this.dataService.accountBalanceItemComponentResolved.next(false); }
        }).catch((reson) => {
            this.dataService.accountBalanceItemComponentResolved.next(false);
        })
    }

    refreshData(page: number, consumerId: string, timePeriod: number) {
        this.consumerService.getHistoryAccount(this.clientId, page, consumerId, timePeriod).then((accountRes) => {
            var result = (accountRes as any);
            this.historyAccounts = [];
            if (result && result.items.length > 0) {
                this.dataService.accountBalanceItemComponentResolved.next(true);
                this.historyAccounts = result.items;
                this.historyAccountsPageSize = result.pageSize;
                this.historyAccountsTotalPages = result.totalPages;
            } else { this.dataService.accountBalanceItemComponentResolved.next(false); }

        }).catch((reson) => {
            this.dataService.accountBalanceItemComponentResolved.next(false);
        })
    }
}
